import z from 'zod';

export const postShippingLists = {
  body: z.object({
    name: z.string().nonempty({ error: 'Shipping list name is required' }),
  }),
  response: z.object({
    id: z.number(),
    name: z.string(),
    project: z.number(),
    release: z.number(),
  }),
  params: z.object({
    project_id: z.coerce.number(),
    release_id: z.coerce.number(),
  }),
  query: z.never(),
};
const postShippingListsSchema = z.object(postShippingLists);
export type PostShippingLists = z.infer<typeof postShippingListsSchema>;

const getShippingLists = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      project: z.number(),
      release: z.number(),
    }),
  ),
  params: z.object({
    project_id: z.coerce.number(),
    release_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getShippingListsSchema = z.object(getShippingLists);
export type GetShippingLists = z.infer<typeof getShippingListsSchema>;

const getShippingListPackingSlips = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    }),
  ),
  params: z.object({
    release_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getShippingListPackingSlipsSchema = z.object(getShippingListPackingSlips);
export type GetShippingListPackingSlips = z.infer<
  typeof getShippingListPackingSlipsSchema
>;

const getShippingListEligibleFrames = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      release_number: z.string(),
      frame_id: z.number(),
      frame_name: z.string(),
      quantity: z.number(),
    }),
  ),
  params: z.object({
    release_id: z.coerce.number(),
    packing_slip_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getShippingListEligibleFramesSchema = z.object(
  getShippingListEligibleFrames,
);
export type GetShippingListEligibleFrames = z.infer<
  typeof getShippingListEligibleFramesSchema
>;

export const postShippingListFrames = {
  body: z.array(
    z.object({
      packing_slip: z.coerce.number(),
      frame_id: z.coerce.number(),
      quantity: z.coerce.number(),
    }),
  ),
  response: z.object({
    id: z.number(),
    name: z.string(),
    created_at: z.date(),
    items: z.array(
      z.object({
        id: z.number(),
        packing_slip: z.number(),
        packing_slip_name: z.string(),
        frame_id: z.number(),
        frame_name: z.string(),
        quantity: z.number(),
      }),
    ),
  }),
  params: z.object({
    shipping_list_id: z.coerce.number(),
  }),
  query: z.never(),
};
const postShippingListFramesSchema = z.object(postShippingListFrames);
export type PostShippingListFrames = z.infer<
  typeof postShippingListFramesSchema
>;

export const getShippingListFrames = {
  body: z.never(),
  response: z.object({
    id: z.number(),
    name: z.string(),
    created_at: z.date(),
    items: z.array(
      z.object({
        id: z.number(),
        packing_slip: z.number(),
        packing_slip_name: z.string(),
        frame_id: z.number(),
        frame_name: z.string(),
        quantity: z.number(),
        allowed_to_delete: z.number(),
      }),
    ),
  }),
  params: z.object({
    shipping_list_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getShippingListFramesSchema = z.object(getShippingListFrames);
export type GetShippingListFrames = z.infer<typeof getShippingListFramesSchema>;

const deleteShippingListFrames = {
  body: z.array(
    z.object({
      item_id: z.coerce.number().min(1, { error: 'Item id is required' }),
      quantity: z.coerce.number().min(1, { error: 'Quantity is required' }),
    }),
  ),
  response: z.never(),
  params: z.object({
    shipping_list_id: z.coerce.number(),
  }),
  query: z.never(),
};
const deleteShippingListFramesSchema = z.object(deleteShippingListFrames);
export type DeleteShippingListFrames = z.infer<
  typeof deleteShippingListFramesSchema
>;
